import * as React from 'react';
import { ArticleParagraph1, Image } from '@cian/ui-kit';

import * as styles from './ListItem.css';

interface IListItemProps {
  defaultIcon: React.ReactNode;
  logoUrl?: string | null;
  name: string;
}

export const ListItem: React.FC<IListItemProps> = ({ defaultIcon, logoUrl, name }) => {
  return (
    <div className={styles['item']}>
      <div className={styles['logo']}>
        {logoUrl ? <Image src={logoUrl} borderRadius="0" /> : <div className={styles['logo-icon']}>{defaultIcon}</div>}
      </div>
      <div className={styles['content']}>
        <ArticleParagraph1>{name}</ArticleParagraph1>
      </div>
    </div>
  );
};
